import React from 'react';
import { Box, Typography } from '@mui/material';

export default function AboutPage() {
  return (
    <Box
      id="about"
      sx={{
        paddingBottom: '56px',
        borderBottom: '1px solid rgba(111,243,232,0.10)',
        marginBottom: '56px',
      }}
    >
      <Typography
        sx={{
          fontFamily: '"Space Grotesk", sans-serif',
          color: '#EDEFF7',
          fontSize: '22px',
          fontWeight: 600,
          mb: 2,
        }}
      >
        About
      </Typography>
      <Typography
        sx={{
          color: '#A8BEF0',
          fontSize: '17px',
          lineHeight: 1.7,
          maxWidth: '640px',
        }}
      >
        I'm a passionate and versatile full-stack web developer with deep experience
        in building scalable, high-performance web applications. I'm proficient in
        technologies like C#, ASP.NET Core, React.js, and Flutter, and I'm passionate
        about delivering innovative solutions that improve efficiency for organizations.
        With additional expertise in Unity 3D development, I focus on writing clean,
        maintainable code and delivering custom software solutions that align with
        business goals. As a confident communicator with strong problem-solving
        abilities, I'm dedicated to consistently achieving results.
      </Typography>
    </Box>
  );
}
